<template>
    <div class="bg-white p-6 shadow-md">
        <h2 class="text-xl font-semibold text-gray-800 mb-4 flex items-center">
            <span class="mr-1">👔</span>
            <span>Top Employers</span>
        </h2>
        <apexchart width="100%" type="bar" :options="chartOptions" :series="series" />
        <base-modal v-if="isShow" title="Other Employers" height="" @close="isShow = false">
            <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-100 sticky top-0 z-10">
                        <tr>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                #
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Employer
                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Count
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-100">
                        <tr v-for="(employer, index) in otherEmployersData" :key="index"
                            class="hover:bg-gray-50 transition-colors">
                            <td class="px-6 py-4 text-sm text-gray-700 font-medium">{{ index + 1 }}</td>
                            <td class="px-6 py-4 text-sm text-gray-900">{{ employer.employer }}</td>
                            <td class="px-6 py-4 text-sm text-indigo-600 font-semibold">{{ employer.count }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </base-modal>
    </div>
</template>

<script>
export default {
    name: "employed-by-employer",
    props: ["data", "otherEmployersData"],
    emits: ["employer-click"],
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    type: 'bar',
                    height: 350,
                    events: {
                        dataPointSelection: (event, chartContext, config) => {
                            const index = config.dataPointIndex;
                            const category = this.chartOptions.xaxis.categories[index];
                            if (category === 'Other Employers') {
                                this.isShow = true;
                            } else if (category) {
                                this.$emit('employer-click', category);
                            }
                        },
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '60%',
                        distributed: true,
                    },
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '12px',
                    },
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: 'Number of Employees'
                    }
                },
                yaxis: {
                    labels: {
                        style: {
                            fontSize: '12px',
                        },
                    },
                },
                tooltip: {
                    y: {
                        formatter: val => `${val} employed`,
                    },
                },
                colors: [],
                legend: {
                    show: false,
                },
            },
            isShow: false,
        };
    },
    watch: {
        data: {
            handler(newData) {
                if (!Array.isArray(newData)) return;

                const categories = [];
                const values = [];

                newData.forEach(item => {
                    categories.push(item.employer);
                    values.push(item.count);
                });

                const powerBIColors = [
                    "#01B8AA", // teal
                    "#374649", // dark gray
                    "#FD625E", // red
                    "#F2C80F", // yellow
                    "#5F6B6D", // gray
                    "#8AD4EB", // light blue
                    "#FE9666", // orange
                    "#A66999", // purple
                    "#3599B8", // blue
                    "#DFBFBF", // pinkish gray
                    "#B6992D"  // golden brown (added)
                ];

                this.series = [{ name: "Employees", data: values }];
                this.chartOptions = {
                    ...this.chartOptions,
                    xaxis: {
                        ...this.chartOptions.xaxis,
                        categories,
                    },
                };
                this.chartOptions.colors = powerBIColors.slice(0, values.length);
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>